import React from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@shared/ui';
import { Filter } from 'iconsax-react';
import { Tags, SkeletonCard } from '@shared/ui';
import { X } from '@/icons/iconsComponent';

export const FilterToggle = ({
  isMobile,
  children,
  isLoading = false,
  title,
  open,
  toggle,
}: {
  isMobile: boolean;
  children: React.ReactNode;
  isLoading: boolean;
  title: string;
  open: boolean;
  toggle: (open: boolean) => void;
}) => {
  const trigger = (
    <div className='cursor-pointer gap-[5px] flex items-center justify-start'>
      {isLoading ? (
        <SkeletonCard className='h-[33px] w-[86px]' />
      ) : (
        <Tags
          title={''}
          variant={'prefix'}
          icon={<Filter size={16} />}
          className='!bg-blue-1 text-white'
        >
          {title}
        </Tags>
      )}
    </div>
  );
  return isMobile ? (
    <Drawer open={open} onOpenChange={toggle}>
      <DrawerTrigger>{trigger}</DrawerTrigger>
      <DrawerContent className='p-4'>
        <DrawerHeader className='flex flex-row items-center justify-between border-b border-border pb-[29px] h-[67px]'>
          <DrawerTitle className='flex items-center gap-1 text-text text-base font-bold'>
            <Filter size={20} className='text-text' />
            {title}
          </DrawerTitle>
          <DrawerClose>
            <X strokeWidth={1} />
          </DrawerClose>
        </DrawerHeader>
        {children}
      </DrawerContent>
    </Drawer>
  ) : (
    <Dialog open={open} onOpenChange={toggle}>
      <DialogTrigger>{trigger}</DialogTrigger>
      <DialogContent className='max-w-[430px]'>
        <DialogHeader className='p-5'>
          <DialogTitle className='text-text text-sm font-bold flex gap-1 items-center'>
            <Filter size={20} className='text-text' />
            {title}
          </DialogTitle>
          <DialogClose onClick={() => toggle(false)}>
            <X strokeWidth={1} />
          </DialogClose>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
};
